import { useCallback, useEffect, useState } from 'preact/hooks';

const synth = window.speechSynthesis;

/**
 *
 * @returns {SpeechSynthesisVoice[]}
 */
export default function useVoices() {
  const [voices, setVoices] = useState([]);

  const populateVoiceList = useCallback(() => {
    setVoices(
      synth.getVoices().filter((voice) => !voice.name.includes('Google') && !voice.name.includes('Desktop'))
    );
  }, []);

  useEffect(() => {
    populateVoiceList();
    if ('onvoiceschanged' in synth) {
      synth.onvoiceschanged = populateVoiceList;
    }
  }, [populateVoiceList]);

  return voices;
}
